import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';


import {Amplify} from "aws-amplify";
import { environment } from '../environments/environment';
import { authInterceptor } from './interceptors/auth.interceptor';
import { TimeagoModule } from 'ngx-timeago';



Amplify.configure({

  Auth: {
    Cognito: {
      userPoolClientId: environment.userPoolClientId,
      userPoolId: environment.userPoolId,
      //identityPoolId: "us-west-2:f0eaf4a7-81b5-4c77-8c95-388d9050251e",
      signUpVerificationMethod: "code",
      loginWith: {
        username: true
      }
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(
      TimeagoModule.forRoot()
    ),
  ]
};
